import {
  Box,
  Button,
  Grid,
  TextField,
  InputLabel,
  Autocomplete,
} from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  drivers,
  driverActiveStatus,
}) => {
  return (
    <Grid container spacing={2}>
      {/* Driver Autocomplete Filter */}
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Driver
        </InputLabel>
        <Autocomplete
          disablePortal
          options={drivers}
          getOptionLabel={(option) => option.full_name}
          isOptionEqualToValue={(option, value) =>
            String(option.driver_id) === String(value.driver_id)
          }
          value={
            filterData.driver_id
              ? drivers.find(
                  (d) => String(d.driver_id) === String(filterData.driver_id)
                ) || null
              : null
          }
          onChange={(_, newValue) => {
            handleChangeFilter("driver_id")(
              null,
              newValue ? newValue.driver_id : ""
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="Select Driver"
            />
          )}
        />
      </Grid>

      {/* Start Date Filter */}
      <Grid item xs={12} md={6} lg={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Start Date
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={filterData.start_date}
            onChange={(newValue) =>
              handleChangeFilter("start_date")(null, newValue)
            }
            format="DD/MM/YYYY"
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>

      {/* End Date Filter */}
      <Grid item xs={12} md={6} lg={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          End Date
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={filterData.end_date}
            onChange={(newValue) =>
              handleChangeFilter("end_date")(null, newValue)
            }
            format="DD/MM/YYYY"
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>

      {/* Is Active Autocomplete Filter */}
      {/* <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Is Active
        </InputLabel>
        <Autocomplete
          disablePortal
          options={driverActiveStatus}
          getOptionLabel={(option) => option.name}
          isOptionEqualToValue={(option, value) =>
            String(option.id) === String(value.id)
          }
          value={
            filterData.active_driver
              ? driverActiveStatus.find(
                  (s) => String(s.id) === String(filterData.active_driver)
                ) || null
              : null
          }
          onChange={(_, newValue) => {
            handleChangeFilter("active_driver")(
              null,
              newValue ? newValue.id : ""
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="Select Active Status"
            />
          )}
        />
      </Grid> */}

      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{
              marginRight: 2,
              textTransform: "none",
              color: "#48505E",
              borderColor: "#E0E0E0",
            }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            onClick={handleFilter}
            endIcon={<ArrowForward />}
            sx={{
              backgroundColor: "#7152F3",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#5c34fa",
              },
            }}
          >
            Filter
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
